import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export default class extends Controller {
	connect() {
		gsap.registerPlugin(ScrollTrigger)

		gsap.fromTo(
			this.collectionItems,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 0.75,
				stagger: 0.25,
				delay: 0.25,
				scrollTrigger: {
					trigger: this.element,
					start: "top 75%"
				}
			}
		)
	}

	get collectionItems() {
		return this.element.querySelectorAll(".collection__piece")
	}
}
